import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import router from './router'
import App from "./App.vue";
import "intersection-observer";
import "sanitize.css";
import vSelect from "vue-select";
import "./assets/sass/styles.sass";
import VueMask from "v-mask";
import Meta from "vue-meta";
import VueAnalytics from "vue-analytics";
// import VueGtm from "vue-gtm";
// import  "FormData";

Vue.component("v-select", {
  extends: vSelect,
  methods: {
    maybeAdjustScroll: () => false
  }
});

Vue.use(VueAnalytics, {
  id: "UA-129360130-1"
});
// Vue.use(VueGtm, {
//   id: "GTM-KHWZ5JX" // Your GTM ID
// });
Vue.use(VueMask);
Vue.use(VueAxios, axios);
Vue.use(Meta);

Vue.config.productionTip = false;

// export const eventBus = new Vue();

new Vue({
  render: h => h(App),
  router
}).$mount("#vincode-app");
